/**
 * Created by gokselpirnal on 17/08/2017.
 */
export const EMPLOYEE = 'EMPLOYEE';
export const MANAGER = 'MANAGER';
export const HR = 'HR';
export const ACCOUNTING = 'ACCOUNTING';



// WEBPACK FOOTER //
// ./src/constants/roles.js